import {Injectable} from '@angular/core';
import {FoerdermittelcheckAnfrage} from '../anfrage/foerdermittelcheck.anfrage';
import {FoerdermittelcheckBackendService} from './backend.service';
import {PortalService} from '../../services/portal.service';
import {Router} from "@angular/router";
import {RequestService} from "../../services/request.service";
import {EmbedService} from "../../services/embed.service";
import {RequestAnfrage} from "../../model/request.anfrage";

/**
 * global advisordata that can be injected by the backend
 * @var object
 */
declare let advisorObjectData;

/**
 * Service for saving the request data locally in the browser to have it on all steps.
 */
@Injectable({
  providedIn: 'root'
})
export class FoerdermittelcheckRequestService extends RequestService {

  /**
   * @inheritdoc
   */
  requestObjectName = 'foc-anfrage';

  /**
   * constructor.
   * @param backendService
   * @param router
   * @param portalService
   * @param embedService
   */
  constructor(public backendService: FoerdermittelcheckBackendService, private router: Router,
              protected portalService: PortalService, protected embedService: EmbedService) {
    super(backendService, portalService, embedService);

    try {
      if (typeof advisorObjectData === "object" && typeof localStorage === "object") {
        // save injected data
        localStorage.setItem(this.requestObjectName, JSON.stringify(advisorObjectData));

        // if we preset the data, redirect to result step
        this.router.navigate([this.portalService.currentPortalId + '/foerdermittelcheck/ergebnis/foerdermittel']);
      }
    } catch (e) {

    }

    this.loadDataFromLocalStorage();
  }

  /**
   * @inheritdoc
   */
  getNewAnfrage(): RequestAnfrage {
    return new FoerdermittelcheckAnfrage();
  }

  /**
   * @inheritdoc
   */
  getAnfrage(): FoerdermittelcheckAnfrage {
    return super.getAnfrage() as FoerdermittelcheckAnfrage;
  }


}
